var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"disabled":_vm.disabled,"label":_vm.label,"rules":_vm.rules,"hide-details":_vm.hideDetails,"validate-on-blur":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }